import field from "./field.mjs";
export default {
  /**
   * @param value - AENS name
   */
  serialize(value) {
    return field.serialize(value);
  },
  /**
   * @param value - AENS name
   */
  deserialize(value) {
    return field.deserialize(value);
  }
};
//# sourceMappingURL=name.mjs.map